import { render, staticRenderFns } from "./PackagesList.vue?vue&type=template&id=120e85b7&scoped=true"
import script from "./PackagesList.vue?vue&type=script&lang=js"
export * from "./PackagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120e85b7",
  null
  
)

export default component.exports